// Cloned from https://github.com/jaredLunde/react-hook/blob/master/packages/merged-ref/src/index.tsx to circumvent import issues
import React from "../__compat__/react/main.entry.mjs.mjs";
export function useMergedRef(...refs) {
    return React.useCallback((element) => {
        for (let i = 0; i < refs.length; i++) {
            const ref = refs[i];
            if (typeof ref === 'function') {
                ref(element);
            }
            else if (ref && typeof ref === 'object') {
                ref.current = element;
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}
//# sourceMappingURL=useMergedRef.mjs.mjs.map